export default class Card {
  number = ''

  cvv = ''

  holder = ''

  month?: number

  year?: number

  installments: number

  constructor(cardInstallments = 1) {
    this.installments = cardInstallments
  }
}
